import { render, staticRenderFns } from "./WomenSysVip.vue?vue&type=template&id=8794f946&scoped=true"
import script from "./WomenSysVip.vue?vue&type=script&lang=js"
export * from "./WomenSysVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8794f946",
  null
  
)

export default component.exports